module.exports = __webpack_public_path__ + "static/masthead-ff1d68fc336384982a9d486f708acc61.jpg";